import { useMemo } from 'react';

import { getIn } from '@gogame/form';

import { PLATFORM } from '../constants';

export const useGetPlatformPermissions = (platformId, hierarchyState) => {
  return useMemo(() => {
    const platforms = getIn(hierarchyState, `${PLATFORM}.data`) || [];
    const selectedPlatform = platforms.find((net) => net.id === platformId);

    if (selectedPlatform) {
      return selectedPlatform;
    }

    return {
      conversionPagesAvailable: false,
      checkInstallsAvailable: false,
      partnerIdAvailable: false,
      reEngagementAvailable: false,
      linkFormatAvailable: false,
      isMobile: false,
      isGgLinkAvailable: false,
    };
  }, [hierarchyState, platformId]);
};
